import { render } from "./RatingCriteria.vue?vue&type=template&id=228b83b0&scoped=true&ts=true"
import script from "./RatingCriteria.vue?vue&type=script&lang=ts"
export * from "./RatingCriteria.vue?vue&type=script&lang=ts"

import "./RatingCriteria.vue?vue&type=style&index=0&id=228b83b0&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228b83b0"]])

export default __exports__